import React from 'react';

// define manually if keys aren't mapping
const manualShortKeyMap = {
  'Emergency Room Care': 'Emergency Room',
  'Emergency Room': 'Emergency Room',
  'Outpatient Mental Health': 'Outpatient',
} as { [shortName: string]: string };

// Helper function to normalize field names for flexible matching
const normalizeFieldName = (fieldName: string): string => {
  return fieldName
    .replace(/\s+/g, '') // Remove all spaces
    .toLowerCase();
};

export const getLabelsSuperscript = (
  planLabels: any[],
  shortName: string,
  networkType: 'IN' | 'OUT'
) => {
  const assignedKey = manualShortKeyMap[shortName] || null;
  const normalizedShortName = normalizeFieldName(shortName);

  const parameter = planLabels?.find((label) => {
    const labelShortName = label?.shortName?.trim();
    const normalizedLabelShortName = normalizeFieldName(labelShortName || '');

    return (
      (labelShortName === shortName?.trim() ||
        (assignedKey && labelShortName === assignedKey) ||
        // Flexible matching: normalize both names and compare (handles "Mail Order" vs "Mailorder")
        normalizedLabelShortName === normalizedShortName) &&
      label?.network === networkType
    );
  });

  return parameter?.labelVOs?.map((label: any) => label?.superscript) || [];
};

export const getLabelsSuperscriptWithKey = (
  planLabels: any[],
  key: string,
  networkType: 'IN' | 'OUT'
): string => {
  const parameter = planLabels?.find(
    (label) => label?.key === key && label?.network === networkType
  );

  const superscripts =
    parameter?.labelVOs?.map((label: any) => label?.superscript) || [];

  // Return joined superscripts or an empty string if no superscripts are found
  return superscripts?.length > 0 ? superscripts.join(', ') : '';
};

export const getSupTextFromReactNode = (node: React.ReactNode): string => {
  if (typeof node === 'string' || typeof node === 'number') {
    return '';
  }

  if (React.isValidElement(node)) {
    if (node.type === 'sup') {
      const supText = node.props.children || '';
      return supText ? `(${supText})` : '';
    }

    if (node.props && node.props.children) {
      if (Array.isArray(node.props.children)) {
        for (const child of node.props.children) {
          const supText = getSupTextFromReactNode(child);
          if (supText) return supText;
        }
      } else {
        return getSupTextFromReactNode(node.props.children);
      }
    }
  }

  return '';
};
